import styles from './Footer.module.css';
import { SOCIAL_LINKS, SOCIAL_LABELS, SITE_TAGLINE } from '../../config/site';

interface FooterProps {
  /** App version string rendered in the bottom row, e.g. "1.1.4". */
  version: string;
  /** Current year for the copyright line. */
  year: number;
}

const PRODUCT_LINKS = [
  { label: 'Features', href: '/#features' },
  { label: 'Pricing', href: '/#pricing' },
  { label: 'Join the Waitlist', href: '/#waitlist' },
  { label: 'Sign In', href: '/auth' },
];

export default function Footer({ version, year }: FooterProps): JSX.Element {
  const socials = Object.entries(SOCIAL_LINKS).filter(([, url]) => Boolean(url));

  return (
    <footer className={styles.footer}>
      <div className={styles.columns}>
        <div className={styles.column}>
          <span className={styles.brand}>PitchVault</span>
          <span className={styles.brandTagline}>{SITE_TAGLINE}</span>
        </div>

        <div className={styles.column}>
          <span className={styles.heading}>Product</span>
          {PRODUCT_LINKS.map((l) => (
            <a key={l.label} href={l.href} className={styles.link}>
              {l.label}
            </a>
          ))}
        </div>

        <div className={styles.column}>
          <span className={styles.heading}>Legal</span>
          <a href="/privacy" className={styles.link}>
            Privacy Policy
          </a>
          <a href="/terms" className={styles.link}>
            Terms of Service
          </a>
        </div>

        {socials.length > 0 && (
          <div className={styles.column}>
            <span className={styles.heading}>Follow</span>
            {socials.map(([key, url]) => (
              <a
                key={key}
                href={url ?? undefined}
                className={styles.link}
                target="_blank"
                rel="noopener noreferrer"
              >
                {SOCIAL_LABELS[key as keyof typeof SOCIAL_LABELS]}
              </a>
            ))}
          </div>
        )}
      </div>

      <div className={styles.bottomRow}>
        <span className={styles.version}>
          v{version} &nbsp;&middot;&nbsp; &copy; {year} PitchVault
        </span>
        <span className={styles.credit}>
          Created by{' '}
          <a href="https://www.gigadude.com" target="_blank" rel="noopener noreferrer">
            gigadude
          </a>
        </span>
        <span className={styles.tagline} data-testid="footer-tagline">
          <a href="https://www.pitchvault.co">www.pitchvault.co</a>
        </span>
      </div>
    </footer>
  );
}
